var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-field text-left"},[_c('div',{class:[
      'font-weight-bold mb-1 blue-grey--text d-flex',
      {
        'text--lighten-2': _vm.disabled,
        'text--darken-3': !_vm.disabled,
        'text-caption-1': _vm.small,
        'text-body-2 text-md-body-1': !_vm.small,
      },
    ]},[_vm._t("pre-icon"),_c('span',{staticClass:"flex-grow-1"},[_vm._v(" "+_vm._s(_vm.label)),(_vm.required)?_c('span',{staticClass:"form-field__symbol"},[_vm._v("*")]):_vm._e()])],2),_vm._t("default"),(_vm.required && !_vm.hiddenRequiredInfo)?_c('span',{staticClass:"d-block text-caption blue-grey--text"},[_c('span',{staticClass:"red--text"},[_vm._v("*")]),_vm._v(" заполняется обязательно ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }